<div class="d-flex justify-content-between flex-row flex-wrap gap-3 mb-2">
  <h4 class="text-primary">Organization Ownership</h4>

  @if (!isLoading() && !errorMessage()) {
    @if (currentOwner()) {
      <button
        [disableWithoutPermission]="{ requiredPermissions: [RolePermission.OrgOwner], userPermissionOnly: false }"
        type="button"
        class="btn btn-primary"
        (click)="openTransferSelector()">
        Transfer Ownership
      </button>
    } @else {
      <button
        [disableWithoutPermission]="{ requiredPermissions: [RolePermission.OrgOwner], userPermissionOnly: false }"
        type="button"
        class="btn btn-primary d-flex gap-2"
        (click)="openAssignSelector()">
        <fa-duotone-icon icon="user-plus" class="me-2" />
        Assign Owner
      </button>
    }
  }
</div>

@if (!isLoading() && !errorMessage()) {
  @if (currentOwner()) {
    <div class="alert alert-warning" role="alert">
      <fa-duotone-icon icon="triangle-exclamation" class="me-2" />
      <strong>Warning:</strong> Transfer of Org Ownership gives the new Org Owner full control of the Organization's online affairs, and removes Org Owner privileges from the current Org Owner.
    </div>
  } @else {
    <div class="alert alert-warning" role="alert">
      <fa-duotone-icon icon="circle-info" class="me-2" />
      <strong>Note:</strong> This organization has no owner assigned. Assigning an owner grants that member full control of the Organization's online affairs.
    </div>
  }
}

@if (errorMessage()) {
  <div class="alert alert-danger" role="alert">
    <fa-duotone-icon icon="circle-exclamation" class="me-2" />
    {{ errorMessage() }}
  </div>
}

@if (!errorMessage()) {
  <div class="row mb-4">
    <div class="col-md-6">
      <label class="form-label fw-bold fs-5">Current Organization Owner:</label>
      @if (isLoading()) {
        <div class="d-flex align-items-center">
          <div class="placeholder-glow w-100">
            <span class="placeholder col-8"></span>
          </div>
        </div>
      } @else if (currentOwner()) {
        <div class="d-flex align-items-center">
          <div>
            <div class="fs-5">{{ currentOwner()!.firstName }} {{ currentOwner()!.lastName }}</div>
            <div class="text-muted fst-italic">{{ currentOwner()!.emailAddress }}</div>
          </div>
        </div>
      } @else {
        <p class="text-muted">No owner assigned</p>
      }
    </div>
  </div>
}


<!-- Transfer: Member Selector Modal -->
<div class="modal fade" id="transferOwnershipMemberSelectorModal" tabindex="-1" aria-labelledby="transferOwnershipMemberSelectorModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="transferOwnershipMemberSelectorModalLabel">Select New Organization Owner</h5>
      </div>
      <div class="modal-body">
        <ms-member-list
          #transferMemberList
          [currentMemberListViewLocation]="MemberListViewLocations.TransferOrganizationOwnershipModal"
          [filterRoleId]="orgAdminRoleId()"
          [currentOwnerId]="currentOwner()?.memberId"
          [transferringOrgId]="organization().organizationId"
          (memberSelectedForOwnershipTransfer)="onMemberSelectedForTransfer($event)"
        />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-ms-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Transfer Confirmation Modal -->
<ms-confirmation-modal
  #transferConfirmationModalRef
  modalId="transferOwnershipConfirmationModal"
  [isSubmitting]="isTransferring()"
  (confirmed)="onTransferConfirmed()"
  (cancelled)="onTransferCancelled()"
/>

<!-- Transfer Result Info Modal -->
<ms-info-modal
  #transferInfoModalRef
  modalId="transferOwnershipInfoModal"
/>


<!-- Assign: Member Selector Modal -->
<div class="modal fade" id="assignOwnershipMemberSelectorModal" tabindex="-1" aria-labelledby="assignOwnershipMemberSelectorModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assignOwnershipMemberSelectorModalLabel">Select Organization Owner</h5>
      </div>
      <div class="modal-body">
        <ms-member-list
          #assignMemberList
          [currentMemberListViewLocation]="MemberListViewLocations.TransferOrganizationOwnershipModal"
          [transferringOrgId]="organization().organizationId"
          [isAssignOwnerFlow]="true"
          (memberSelectedForOwnershipTransfer)="onMemberSelectedForAssign($event)"
        />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-ms-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Assign Confirmation Modal -->
<ms-confirmation-modal
  #assignConfirmationModalRef
  modalId="assignOwnershipConfirmationModal"
  [isSubmitting]="isAssigning()"
  (confirmed)="onAssignConfirmed()"
  (cancelled)="onAssignCancelled()"
/>

<!-- Assign Result Info Modal -->
<ms-info-modal
  #assignInfoModalRef
  modalId="assignOwnershipInfoModal"
/>
